import React from 'react'
import PropTypes from 'prop-types'
import FormX from 'sb-formx'
import { useWillUnmount } from 'sb-hooks'
import { constants } from 'common/helpers'
import { required } from 'helpers/validation'

import Field from 'components/_new/forms/Field/Field'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './ReplyForm.scss'


const form = new FormX({
  name: 'ReplyForm',
  fields: {
    message: [ required ],
  },
})

const ReplyForm = ({ className, onSubmit, onCancel }) => {
  const handleSubmit = () => {
    form.submit()
      .then((values) => {
        onSubmit(values)
      })
  }

  useWillUnmount(() => {
    form.unsetValues()
  })

  return (
    <div className={className}>
      <Field
        field={form.fields.message}
        label={messages.placeholder}
        dataTestId={constants.testIds.replyForm.message}
        standardView
        rows={3}
      />
      <div className={s.actions}>
        <div className={s.buttons}>
          <CommonButton
            className={s.cancelButton}
            cancel
            textButton
            md
            dataTestId={constants.testIds.replyForm.cancelButton}
            onClick={onCancel}
          />
          <Button
            className={s.replyButton}
            title={messages.reply}
            brand
            md
            dataTestId={constants.testIds.replyForm.submitButton}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

ReplyForm.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}


export default ReplyForm
